import { NextPage, NextPageContext } from 'next'
import React from 'react'
import Error from '../../_error'
import { InvestorTemplate } from '@/components/pages/investor/InvestorTemplate'
import { PaginationFromPageInfo } from '@/components/common/PaginationFromPageInfo'
import { PeopleTable } from '@/components/pages/investor/PeopleTable'
import { fetchInvestorSummary, getPeople } from '@/lib/api/investor'
import { investorTypeOf } from '@/lib/investor'
import { pageFromQuery } from '@/lib/page'
import {
  InvestorSummary,
  InvestorType,
  PageApiRespone,
  People,
} from '../../../types'

type Props = {
  summary: InvestorSummary | undefined
  people: PageApiRespone<People> | undefined
  type: InvestorType
}

const InvestorPeoplePage: NextPage<Props> = (props) => {
  if (!props.summary) {
    return <Error />
  }

  return (
    <InvestorTemplate summary={props.summary} tab="people">
      {props.people && props.type && (
        <>
          <PeopleTable
            title={props.type === 'vc' ? 'キャピタリスト' : 'CVC担当'}
            list={props.people.data}
          />
          <PaginationFromPageInfo
            link={{
              href: `/investor/people?shortname=${props.summary.shortname}`,
              as: `/investors/${props.summary.shortname}/people`,
            }}
            limit={props.people.limit}
            offset={props.people.offset}
            count={props.people.count}
          />
        </>
      )}
    </InvestorTemplate>
  )
}

InvestorPeoplePage.getInitialProps = async (ctx: NextPageContext) => {
  const shortname = ctx.query.shortname!.toString()
  const { limit, offset } = pageFromQuery(ctx.query)

  const investorSummaryResponse = await fetchInvestorSummary(ctx, shortname)

  const summary = investorSummaryResponse?.data
  let people: PageApiRespone<People> | undefined
  let type: InvestorType | undefined

  if (summary) {
    type = investorTypeOf(summary)
    people = await getPeople(type, summary.shortname, limit, offset)
  }

  return { summary, people, type }
}

export default InvestorPeoplePage
